<template>
  <component :is="level" class="rwl-heading" :class="[level]"> <slot /> </component>
</template>

<script>
/**
 * Headings are used as the titles of each major section of a page in the
 * interface. For example, templates generally use headings as their title.
 * Heading element provides an option to change the level of the heading.
 */
export default {
  name: "RwlHeading",
  status: "prototype",
  release: "1.0.0",
  props: {
    /**
     * The heading level used for the heading.
     * `h1, h2, h3, h4, h5, h6`
     */
    level: {
      type: String,
      default: "h1",
      validator: value => {
        return value.match(/(h1|h2|h3|h4|h5|h6)/)
      },
    },
  },
}
</script>


<docs>
  ```jsx
  <div>
    <RwlHeading>H1 Headline - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin facilisis in lorem posuere commodo.</RwlHeading>
    <RwlHeading level="h2">H2 Headline - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin facilisis in lorem posuere commodo.</RwlHeading>
    <RwlHeading level="h3">H3 Headline - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin facilisis in lorem posuere commodo.</RwlHeading>
    <RwlHeading level="h4">H4 Headline - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin facilisis in lorem posuere commodo.</RwlHeading>
    <RwlHeading level="h5">H5 Headline - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin facilisis in lorem posuere cnnnnnnnnnnnnnnnnnnnnnnnnndsjknlhsdfhnvsldkn</RwlHeading>
    <RwlHeading level="h6">H6 like Body text - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin facilisis in lorem posuere commodo. ksjbdkjabhdkjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj</RwlHeading>
  </div>
  ```
</docs>
